import { ModelBase } from '../abstract/model-base.model';
import { ItemType } from '../sales/item-type.model';

// Enums
import { ItemTypeEnum } from '../../enums/item-type.enum';

/**
 * Titre de section réutilisable — #1186.
 *
 * Deux listes par dossier, tenues depuis les articles : les titres de **sections** et
 * ceux de **sous-sections**, sans hiérarchie entre elles. Un titre ne sert qu'à
 * **pré-remplir** le nom d'une ligne de devis ou de facture de vente au moment de son
 * ajout : la ligne n'en garde aucun identifiant, et renommer ou supprimer un titre ne
 * change aucun document existant.
 *
 * `level` reprend les codes de {@link ItemTypeEnum} (`section` / `subsection`).
 */
export class ProductSectionTitle extends ModelBase {

    static override CLASS_NAME: string = 'ProductSectionTitle';

    private _label!: string;
    private _level!: ItemType;

    public get isSection(): boolean {
        return this._level?.code === ItemTypeEnum.Section;
    }

    public get isSubSection(): boolean {
        return this._level?.code === ItemTypeEnum.SubSection;
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get level(): ItemType {
        return this._level;
    }

    public set level(value: any) {
        this._setValue('_level', value, 'ItemType');
    }
}
